<template>
    <kgr-lightbox
        headline="Zahlungshistorie"
        :value="show"
        @input="$emit('close')"
    >
        <kgr-loading v-show="loading" />
        <div
            v-show="!loading"
            style="max-width:800px;"
        >
            <div class="kgr-row">
                <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--125">
                    <dt
                        class="kgr-definitionList__term"
                    >
                        Neu
                    </dt>
                    <dd
                        class="kgr-definitionList__definition"
                    >
                        <div class="kgr-inputGroup">
                            <div
                                class="kgr-grid kgr-grid--full kgr-grid--medium-fit kgr-grid--gutters"
                                style="align-items: end;"
                            >
                                <div class="kgr-grid__cell">
                                    <kgr-form-row
                                        label="Start"
                                        :error="error"
                                        field-name="start"
                                    >
                                        <kgr-date-picker
                                            v-model="newPaymentMethodHistoryElement.start"
                                        />
                                    </kgr-form-row>
                                </div>
                                <div class="kgr-grid__cell">
                                    <kgr-form-row
                                        label="Zahlungsart"
                                        :error="error"
                                        field-name="paymentMethod"
                                    >
                                        <kgr-member-payment-method-select
                                            v-model="newPaymentMethodHistoryElement.paymentMethod"
                                            :sepa-disabled="!sepaMandateAvailable"
                                            :default-payment-method="defaultPaymentMethod"
                                        />
                                    </kgr-form-row>
                                </div>
                                <div
                                    v-if="newPaymentMethodHistoryElement.paymentMethod?.value === 'sepa-debit'"
                                    class="kgr-grid__cell"
                                >
                                    <kgr-form-row
                                        label="SEPA-Lastschrift"
                                        :error="error"
                                        field-name="paymentMethod"
                                    >
                                        <kgr-member-sepa-debit-select
                                            v-model="newPaymentMethodHistoryElement.sepaDebit"
                                            :member-id="memberId"
                                        />
                                    </kgr-form-row>
                                </div>
                                <div class="kgr-grid__cell">
                                    <kgr-button
                                        value="Hinzufügen"
                                        @click="add"
                                    />
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--125">
                <template
                    v-for="(paymentMethodHistoryElement, index) in paymentMethodHistoryElements"
                    :key="index + 'row'"
                >
                    <dt
                        class="kgr-definitionList__term"
                    >
                        <kgr-icon
                            icon-class="delete"
                            small
                            @click="deleteElement(paymentMethodHistoryElement.id)"
                        />
                        ab {{ getStart(paymentMethodHistoryElement) }}:
                    </dt>
                    <dd
                        class="kgr-definitionList__definition"
                    >
                        {{ getType(paymentMethodHistoryElement) }}
                    </dd>
                    <dd
                        class="kgr-definitionList__definition"
                    >
                        {{ getDetails(paymentMethodHistoryElement) }}
                    </dd>
                </template>
            </dl>
        </div>
    </kgr-lightbox>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker.vue'
import Error from '../../../js/model/Error.js'
import FormRow from '../../common/form/FormRow.vue'
import Helper from '../../../js/accounting/Helper.js'
import Icon from '../../common/icon/Icon.vue'
import KgrButton from '../../common/form/button/KgrButton.vue'
import Lightbox from '../../common/modal/Lightbox.vue'
import Loading from '../../common/Loading.vue'
import MemberPaymentMethodSelect from '../../common/form/select/MemberPaymentMethodSelect.vue';
import MemberSepaDebitSelect from '../../common/form/select/MemberSepaDebitSelect.vue';
import axios from 'axios';
import { format } from '@legacy/js/date/date-fns.js';

export default {
    components: {
        'kgr-lightbox': Lightbox,
        'kgr-loading': Loading,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-button': KgrButton,
        'kgr-icon': Icon,
        'kgr-member-payment-method-select': MemberPaymentMethodSelect,
        'kgr-member-sepa-debit-select': MemberSepaDebitSelect,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            error: new Error(),
            paymentMethodHistoryElements: [],
            newPaymentMethodHistoryElement: null,
            showNew: false,
            defaultPaymentMethod: 'indefinite',
            sepaMandateAvailable: null,
        }
    },
    created() {
        this.load();
        this.loadMemberSettings();
        this.initNew();
    },
    methods: {
        load() {
            this.loading = true;
            axios
                .get('/club/member-club-fees/' + this.id + '/payment-method-history-elements')
                .then(response => {
                    this.paymentMethodHistoryElements = response.data.data;
                    this.loading = false;
                });
        },
        loadMemberSettings() {
            this.loading = true;
            axios
                .get('/club/members/' + this.memberId + '/settings')
                .then(response => {
                    this.defaultPaymentMethod = response.data.data.defaultPaymentMethod;
                    this.sepaMandateAvailable = response.data.data.sepaMandateAvailable;
                    this.newPaymentMethodHistoryElement.paymentMethod = this.defaultPaymentMethod;
                    this.loading = false;
                });
        },
        add() {
            this.loading = true;
            let paymentMethod = {
                type: this.newPaymentMethodHistoryElement.paymentMethod.value,
            };
            if (this.newPaymentMethodHistoryElement.paymentMethod.value === 'sepa-debit') {
                paymentMethod.id = this.newPaymentMethodHistoryElement.sepaDebit?.id;
            }
            axios
                .post('/club/member-club-fees/' + this.id + '/payment-method-history-elements', {
                    start: this.getApiDateFromString(this.newPaymentMethodHistoryElement.start),
                    paymentMethod,
                })
                .then(() => {
                    this.load();
                    this.initNew();
                    this.error = new Error();

                })
                .catch((error) => {
                    this.error = Error.fromResponse(error.response);
                    if(this.error.status === 409) {
                        this.error.add('start', 'Für dieses Datum existiert bereits ein Eintrag.');
                    }
                })
                .finally(() => this.loading = false);
        },
        deleteElement(id) {
            axios
                .delete('/club/payment-method-history-elements/' + id)
                .then(() => this.load());
        },
        getStart(element) {
            return new Helper().formatDate(element.start)
        },
        getDetails(element) {
            if('sepa-debit' !== element.paymentMethod.data.type) {
                return '';
            }
            return '('+ element.paymentMethod.data.details.iban + ') ' + element.paymentMethod.data.details.mandateReferenceNumber;
        },
        getType(element) {
            return new Helper().translatePaymentMethod(element.paymentMethod.data.type);
        },

        getApiDateFromString(string) {
            if (string === null) {
                return null;
            }

            let [day, month, year] = string.split('.');

            return {
                'day': parseInt(day),
                'month': parseInt(month),
                'year': parseInt(year),
            }
        },
        initNew() {
            this.newPaymentMethodHistoryElement = {
                start:              format(new Date(), 'dd.MM.yyyy'),
                paymentMethod: this.defaultPaymentMethod,
                sepaDebit: null,
            };
        },
    },
}
</script>
